// Cycle de vie GLOBAL des runs : l'adoption, l'évacuation mémoire de secours,
// le rapprochement direct des jobs et le watchdog continuent hors du canvas.
import { useEffect } from 'react';
import { useAuth } from '../../auth';
import {
  fetchGenerationJobsByIds,
  subscribePromptHistory,
} from '../../../services/firestore.service';
import { useGenerationQueueStore } from '../store/useGenerationQueueStore';

const RUN_LIFECYCLE_HISTORY_LIMIT = 200;
const STALE_RUN_SWEEP_INTERVAL_MS = 30_000;

export const GenerationRunLifecycle: React.FC = () => {
  const { user } = useAuth();
  const userId = user?.uid;

  useEffect(() => {
    if (!userId) return undefined;
    let active = true;
    let reconciliationInFlight = false;
    const unsubscribe = subscribePromptHistory(
      userId,
      (entries) => {
        if (!active) return;
        const queue = useGenerationQueueStore.getState();
        queue.adoptHistoryEntries(entries);
        queue.evacuateRunPayloads(
          entries.map((entry) => entry.id).filter((id): id is string => Boolean(id))
        );
      },
      (error) => {
        if (active) console.error('[GenerationRunLifecycle] erreur abonnement historique :', error);
      },
      RUN_LIFECYCLE_HISTORY_LIMIT
    );
    const reconcileJobs = async () => {
      if (!active || reconciliationInFlight) return;
      const jobIds = useGenerationQueueStore
        .getState()
        .runs.filter((run) => run.status === 'submitting' || run.status === 'in_progress')
        .map((run) => run.id);
      if (jobIds.length === 0) return;
      reconciliationInFlight = true;
      try {
        const jobs = await fetchGenerationJobsByIds(jobIds);
        if (active) useGenerationQueueStore.getState().reconcileGenerationJobs(jobs);
      } catch (error) {
        if (active) console.error('[GenerationRunLifecycle] erreur rapprochement des jobs :', error);
      } finally {
        reconciliationInFlight = false;
      }
    };
    const sweep = () => {
      if (!active) return;
      useGenerationQueueStore.getState().sweepStaleRuns();
      void reconcileJobs();
    };
    sweep();
    const interval = window.setInterval(sweep, STALE_RUN_SWEEP_INTERVAL_MS);
    return () => {
      active = false;
      unsubscribe();
      window.clearInterval(interval);
    };
  }, [userId]);

  return null;
};
